import {forwardRef} from 'react';

import {Text} from '#component/base';

import {MultiSelect} from '../MultiSelect';

import {MultipleChoiceSelectProps, OptionProps} from './MultipleChoiceSelect.types';

import * as css from './MultipleChoiceSelect.css';

export const Option = forwardRef<HTMLInputElement, OptionProps>(
  ({label, value, fullWidthOption = false, ...otherProps}, ref) => (
    <label className={fullWidthOption ? css.optionFullWidth : css.option}>
      <input
        className={css.optionInput}
        id={`${value || 'selection'}-input`}
        ref={ref}
        value={value}
        {...otherProps}
      />

      <Text className={css.optionLabel} color="inherit" variant="button">
        {label}
      </Text>
    </label>
  ),
);

/**
 * The MultipleChoiceSelect component is used to present a set of inputs for selecting one or many options
 * from a list of provided {id: string, text: string} options. This component functions as a radio input
 * for single selection and as a checkbox type for multiple selection. Since our API consumes the survey
 * submission values for multiple selects as an array of IDs, the onChange handler here passes in the
 * option ID as an argument.
 */
export const MultipleChoiceSelect = ({
  name,
  onChange,
  optionType,
  options = [],
  value = [],
  fullWidthOption = false,
}: MultipleChoiceSelectProps) =>
  optionType == 'radio' ? (
    <fieldset className={css.root}>
      {options.map(({id, text}) => (
        <Option
          checked={!!value.length && (value as string[]).includes(id)}
          key={id}
          label={text}
          name={name}
          onChange={onChange}
          type={optionType}
          value={id}
          fullWidthOption={fullWidthOption}
        />
      ))}
    </fieldset>
  ) : (
    // Using the multi-select checkbox component here
    <MultiSelect onChange={onChange} value={value} options={options} />
  );
